var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.94,
    height: 15.969,
    viewBox: "0 0 22.94 22.969",
    "data-prefix": "ioiap0afu",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.86 17.623a12.182 12.182 0 0 1-2.73 4.188 12.984 12.984 0 0 1-1.09.96l-.23.18-.62.01A19.268 19.268 0 0 1-.01 4.437L0 4.145l.18-.229a11.825 11.825 0 0 1 .96-1.085A12.058 12.058 0 0 1 5.33.099a1.737 1.737 0 0 1 .61-.106 2.159 2.159 0 0 1 1.94 1.04c.55 1.512 1.24 3.487 1.74 5.373a2.3 2.3 0 0 1-.69 2.142L7.16 9.669a.989.989 0 0 0 .21.784 24.9 24.9 0 0 0 2.37 2.779 24.038 24.038 0 0 0 2.76 2.35.966.966 0 0 0 .8.2l1.11-1.761a2.308 2.308 0 0 1 1.75-.723 1.759 1.759 0 0 1 .36.035 24.91 24.91 0 0 1 5.46 1.765 2.279 2.279 0 0 1 .88 2.525zm-16.9-6.138a2.679 2.679 0 0 1-.53-2.088 1.789 1.789 0 0 1 .81-1.209l1.64-1.042a2.629 2.629 0 0 0 .04-.34c-.46-1.7-1.1-3.548-1.62-5a1.516 1.516 0 0 0-.36-.065l-.03.009a10.288 10.288 0 0 0-3.53 2.315 8.647 8.647 0 0 0-.64.7 16.349 16.349 0 0 0 5.07 11.3l.08.073a16.355 16.355 0 0 0 11.3 5.07 9.361 9.361 0 0 0 .7-.64 10.314 10.314 0 0 0 2.34-3.586 2.88 2.88 0 0 0-.12-.378 23.949 23.949 0 0 0-4.97-1.57 1.354 1.354 0 0 0-.36.064l-1.02 1.623a1.737 1.737 0 0 1-1.19.774 2.747 2.747 0 0 1-2.1-.5 27.127 27.127 0 0 1-2.97-2.527 26.213 26.213 0 0 1-2.54-2.983z",
    fillRule: "evenodd",
    className: "path-iu2g1jfld"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.e88d99dd02a1de2fe1f62bcdbcc5486c.svg";
export { ForwardRef as ReactComponent };